import {Type} from "@/interfaces/economy/paymentMethod";
import { TranslatableEntity } from '@/interfaces/translatableEntity';

export class PaymentMethod implements TranslatableEntity {

  private _id: number;
  private _createdAt: string;
  private _updatedAt: string;
  private _name: string;
  private _description: string;
  private _icon: string;
  private _color: string;
  private _type: Type;
  public invoice: boolean;
  private _descriptionTranslationKey: string;
  private _nameTranslationKey: string;

  constructor(id: number, createdAt: string, updatedAt: string, name: string, description: string, icon: string, color: string, type: Type, swedbankPay: boolean, invoice: boolean, descriptionTranslationKey: string, nameTranslationKey: string) {
    this._id = id;
    this._createdAt = createdAt;
    this._updatedAt = updatedAt;
    this._name = name;
    this._description = description;
    this._icon = icon;
    this._color = color;
    this._type = type;
    this.invoice = invoice;
    this._descriptionTranslationKey = descriptionTranslationKey;
    this._nameTranslationKey = nameTranslationKey;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get createdAt(): string {
    return this._createdAt;
  }

  set createdAt(value: string) {
    this._createdAt = value;
  }

  get updatedAt(): string {
    return this._updatedAt;
  }

  set updatedAt(value: string) {
    this._updatedAt = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(value: string) {
    this._icon = value;
  }

  get color(): string {
    return this._color;
  }

  set color(value: string) {
    this._color = value;
  }

  get type(): Type {
    return this._type;
  }

  set type(value: Type) {
    this._type = value;
  }

  get descriptionTranslationKey(): string {
    return this._descriptionTranslationKey;
  }

  get nameTranslationKey(): string {
    return this._nameTranslationKey;
  }
}

/**
 * Helper method to see if PaymentMethod type is Invoice
 */
export function isInvoice(type: Type) {
  switch (type) {
    case Type.INVOICE_POST:
    case Type.INVOICE_EMAIL:
    case Type.INVOICE_PRINT:
      return true;
    default:
      return false;
  }
}

/**
 * Helper method to see if PaymentMethod type is LinkyDinky
 */
export function isPayLink(type: Type) {
  switch (type) {
    case Type.PAYLINK_SMS:
      return true;
    default:
      return false;
  }
}

/**
 * Helper method to see if PaymentMethod type is of type emailInvoice
 */
export function isDownloadInvoice(type: Type) {
  return type === Type.INVOICE_PRINT;
}

/**
 * Helper method to see if PaymentMethod type is digital (swish / card)
 */
export function isDigitalPayment(type: Type): boolean {
  switch (type) {
    case Type.SWISH:
    case Type.CARD:
      return true;
    default:
      return false;
  }
}
